export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/topojson-client/src/identity.js
// module id = 66
// module chunks = 0